// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f514b22f31df01b5","8602":"179603e0177f1512"}[chunkId] + ".css";
};